import axios from 'axios';
import { ISelfRegistrationStepResponse, IUpdateProfilePayload } from 'entities/SelfRegistration/SelfRegistration.models';

const basePath = 'self-registration';

export const selfRegistrationTransport = {
  getStep: (): Promise<ISelfRegistrationStepResponse> => axios.get(`${basePath}/step`),
  updateProfile: (payload: IUpdateProfilePayload): Promise<ISelfRegistrationStepResponse> =>
    axios.patch(`${basePath}/profile`, payload),
  completeLegals: (): Promise<ISelfRegistrationStepResponse> => axios.patch(`${basePath}/legals`),
  completeAddresses: (): Promise<ISelfRegistrationStepResponse> => axios.patch(`${basePath}/addresses`),
  getPreviousStep: (): Promise<ISelfRegistrationStepResponse> => axios.post(`${basePath}/back`),
};
